export const replaceVarInString = (message = '', varArray: Array<string>) => {
  const re = new RegExp(/\{.*?\}/g)
  let index = 0
  return message.replace(re, _ => {
    const value = varArray[index] || ''
    index++
    return value
  })
}
